import { toast } from "react-toastify";
import type { EntityType, FlatContentLayersType } from "@/config";
import { invertFlatData } from "@/shared";
import { getWholeEntityLayers } from "./getWholeEntityLayers";

export const copyNestedToClipboard = ({
  id,
  flatContentLayers,
}: {
  id: string;
  flatContentLayers: FlatContentLayersType;
}) => {
  const entity = flatContentLayers[id];
  if (!entity || !["slide", "element"].includes(entity.type)) return;
  if (entity.childIds.length === 0) {
    const simpleEntity = JSON.stringify({
      id: entity.id,
      type: entity.type,
      settings: entity.settings,
      children: [],
    });
    copyToClipboard(simpleEntity);
    return;
  }
  const payload = getWholeEntityLayers(entity.id, flatContentLayers);
  if (!payload?.entities || !payload?.root) return;

  const root = {
    type: "root",
    id: "root",
    settings: {},
    parentId: null,
    childIds: [payload.root],
  } as EntityType;
  const slide = invertFlatData({ flatData: { root, ...payload.entities } })[0];
  copyToClipboard(JSON.stringify(slide));
};

const copyToClipboard = (data: string) => {
  navigator.clipboard.writeText(data);
  toast.success("Copied to clipboard");
};
